import { createSlice } from '@reduxjs/toolkit';
import { AsyncStatus } from '../../../libs/utils/constants/async-status';
import ISkills from '../../../libs/utils/interfaces/ebpc-interface';
import { getEbpcSkills } from './ebpc-thunk';

const initialState: ISkills = {
    asyncStatus: AsyncStatus.INITIAL,
    ebpcSkillsDetails: [],
    count: 0,
    statusCode: 0,
};

const skillSlice = createSlice({
    name: 'skills',
    initialState,
    reducers: {},
    extraReducers: (builder: any) => {
        builder
            // Get Ebpc Skills
            .addCase(getEbpcSkills.pending, (state: ISkills) => {
                state.asyncStatus = AsyncStatus.LOADING;
                state.count = 0;
                state.statusCode = 0;
            })
            .addCase(
                getEbpcSkills.fulfilled,
                (state: ISkills, { payload }: any) => {
                    state.asyncStatus = AsyncStatus.SUCCESS;
                    state.ebpcSkillsDetails = payload;
                    state.count = payload.length;
                    state.statusCode = payload?.response?.status;
                }
            )
            .addCase(getEbpcSkills.rejected, (state: ISkills) => {
                state.asyncStatus = AsyncStatus.FAILURE;
                state.count = 0;
                state.statusCode = 0;
            });
    },
});

export default skillSlice.reducer;
